//
//example use:
//var initValStart = {
//                          transactionName:'transNameVal',
//                          additionalEVarKeyValuePairs:[{key:'evar1', value:'evarVal1'}, {key:'evar2', value:'evarVal2'},  etc...]
//                   };
//ecommSiteCatalystUtility.init(initValStart);
//ecommSiteCatalystUtility.startTransaction();
//
//var initValComplete = {
//                          transactionName:'transNameVal',
//                          additionalEVarKeyValuePairs:[{key:'evar1', value:'evarVal1'}, {key:'evar2', value:'evarVal2'},  etc...]
//                      };
//ecommSiteCatalystUtility.init(initValComplete);
//ecommSiteCatalystUtility.completeTransaction();
//


var ecommSiteCatalystUtility = (function () {

    var that = {
        transactioneVar: 'eVar2',
        transactionName: 'no_transaction_specified',
        startTransactionEvent: 'event77',
        completeTransactionEvent: 'event78',
        additionalEVarKeyValuePairs: []
    };

    that.init = function (settings) {

        that.transactionName = settings.transactionName || that.transactionName;
        that.additionalEVarKeyValuePairs = settings.additionalEVarKeyValuePairs || []; //if there are no init values, then empty the list
    };

    var processAdditionalEvarKeyValuePairs = function (additionalkvps) {
        var additionalEvarNamesList = '';

        if (additionalkvps.length > 0) {
            for (index = 0; index < additionalkvps.length; index++ ) {
                additionalEvarNamesList = additionalkvps[index].key + ',' + additionalEvarNamesList;
                eval('s.' + additionalkvps[index].key + ' = ' + '"' + additionalkvps[index].value.toLowerCase() + '"');
            }
        }

        return additionalEvarNamesList;
    }
    

    that.startTransaction = function callSiteCatalystStartTransaction(controlClickedName) {

        if (!controlClickedName) {
            controlClickedName = 'startTransactionControlClick';
        }

        fireSiteCatalystTransaction(that.startTransactionEvent, controlClickedName)
    };

    that.continueTransaction = function (scEvent, controlClickedName) {

        if (!controlClickedName) {
            controlClickedName = 'continueTransactionControlClick';
        }

        fireSiteCatalystTransaction(scEvent, controlClickedName);
    };
    
    that.completeTransaction = function callSiteCatalystCompleteTransaction(controlClickedName) {
        if (!controlClickedName) {
            controlClickedName = 'completeTransactionControlClick';
        }

        fireSiteCatalystTransaction(that.completeTransactionEvent, controlClickedName)
    };

    var fireSiteCatalystTransaction = function (scEvent, controlClickedName) {
        window.s = window.s || {};
        var pageNameToLog = (typeof window.s.pageName !== "undefined") ? window.s.pageName : "";

        if (pepWizard.pepDialog.isOpen) {
            var $page = pepWizard.getCurrentPage();
            var frameName = $page.attr('data-frameName');
            var action = pepWizard.pepDialog.$openContent.data('actionName');
            pageNameToLog = 'pemco:members:' + action;
            //window.s.pageName = window.s.pageName.toLowerCase();
            if (frameName && frameName.length <= 15) { //only tag when framework is not a weird long string like cypnb@bamx9kjj36tpuqrh0setgzie@m3v1ozcv$an1hhi8tzlvhaa,,; the maximum length for a menu option inside popup is about 8
                pageNameToLog += ':' + frameName;
            }
        }

        if (!controlClickedName) {
            controlClickedName = 'unknownTransactionControlClick';
        }
        eval('window.s.' + that.transactioneVar + ' = ' + '"' + that.transactionName.toLowerCase() + '"');
        window.s.events = scEvent;
        window.s.eVar18 = window.siteCatalystUID;
        window.s.eVar6 = window.siteCatalystSessionID;
        window.s.linkTrackVars = processAdditionalEvarKeyValuePairs(that.additionalEVarKeyValuePairs) + that.transactioneVar + (that.transactioneVar ? ',' : '') + "eVar18,eVar6,events";
        window.s.linkTrackEvents = scEvent;
        window.s.useForcedLinkTracking = false;

        var dc_payload = {
            pageName: pageNameToLog,
            events: window.s.events,
            controlClickedName: window.s.controlClickedName
        };

        // Find any eVars attached to the s and apply it to the dc_payload
        for (var eVarIndex = 1; eVarIndex < 100; eVarIndex++) {
            if (eval("window.s.eVar" + eVarIndex)) {
                eval("dc_payload.eVar" + eVarIndex + " = window.s.eVar" + eVarIndex + ";");
            }
        }

        if (typeof _satellite !== "undefined") {
            _satellite.track("async_custom_link", dc_payload);
        }

        window.s.events = "";
    };

    that.sendBeacon = function(sc_args, description) {
        if (typeof _satellite === "undefined" || !_satellite) {
            console.log("ERROR: No SiteCatalyst satellite instance available!");
            return;
        }

        var dc_type = (description) ? description : "async_page_view";

        var dc_payload = {};
        dc_payload.pageName = sc_args.pageName;
        dc_payload.events = sc_args.events;

        if (s.controlClickedName) dc_payload.controlClickedName = s.controlClickedName;

        // Find any eVars attached to the s and apply it to the dc_payload
        for (var eVarIndex = 1; eVarIndex < 100; eVarIndex++) {
            if (eval("sc_args.eVar" + eVarIndex)) {
                eval("dc_payload.eVar" + eVarIndex + " = sc_args.eVar" + eVarIndex + ";");
            }
        }

        if (typeof _satellite !== "undefined") {
            _satellite.track(dc_type, dc_payload);
        }
    };

    return that;
}())